import React from "react";
import {
  XYPlot,
  XAxis,
  YAxis,
  LabelSeries,
  MarkSeries,
  RadarChart,
} from "react-vis";
import "react-vis/dist/style.css";
import AutoSizer from "react-virtualized/dist/commonjs/AutoSizer";

import { round } from "../../../store/reducers/dataReducer";
import { storeColors } from "../../../store/reducers/reports";

const XChart = (props) => {
  const { width, height, selectedAttributes, stores, storeStats } = props;

  const series = [
    {
      x: storeStats[selectedAttributes[0]].min,
      y: 0,
      size: 0,
      color: "#F5F7FA",
      opacity: 0,
    },
    ...stores.map((s, index) => ({
      x:
        storeStats[selectedAttributes[0]].type === "percentage"
          ? s.data[selectedAttributes[0]] * 100
          : s.data[selectedAttributes[0]],
      y: 0,
      size: 5,
      label: s.NAME,
      xOffset: 8,
      yOffset: -5,
      rotation: -60,
      style: { fontSize: 10 },
      color: storeColors[index],
    })),
    {
      x: storeStats[selectedAttributes[0]].max,
      y: 0,
      size: 0,
      color: "#F5F7FA",
      opacity: 0,
    },
  ];

  return (
    <XYPlot width={width} height={height} yDomain={[0, 1]}>
      <XAxis
        tickFormat={(v) =>
          storeStats[selectedAttributes[0]].type === "percentage" ? `${v}%` : v
        }
        tickTotal={4}
        title={selectedAttributes[0]}
      />
      <MarkSeries colorType="literal" sizeRange={[5, 5]} data={series} />
      <LabelSeries data={series} labelAnchorX="start" labelAnchorY="text-top" />
    </XYPlot>
  );
};

const XYChart = (props) => {
  const { width, height, selectedAttributes, stores, storeStats } = props;

  const series = [
    {
      x: storeStats[selectedAttributes[0]].min,
      y: storeStats[selectedAttributes[1]].min,
      size: 0,
      color: "#F5F7FA",
      opacity: 0,
    },
    ...stores.map((s, index) => ({
      x:
        storeStats[selectedAttributes[0]].type === "percentage"
          ? s.data[selectedAttributes[0]] * 100
          : s.data[selectedAttributes[0]],
      y:
        storeStats[selectedAttributes[1]].type === "percentage"
          ? s.data[selectedAttributes[1]] * 100
          : s.data[selectedAttributes[1]],
      size: 5,
      label: s.NAME,
      xOffset: 7,
      yOffset: 3,
      // rotation: -60,
      style: { fontSize: 10 },
      color: storeColors[index],
    })),
    {
      x: storeStats[selectedAttributes[0]].max,
      y: storeStats[selectedAttributes[1]].max,
      size: 0,
      color: "#F5F7FA",
      opacity: 0,
    },
  ];

  return (
    <XYPlot
      width={width}
      height={height}
      margin={{
        left: 40,
        top: 30,
        bottom: 30,
        right: 90,
      }}
    >
      <XAxis
        tickFormat={(v) =>
          storeStats[selectedAttributes[0]].type === "percentage" ? `${v}%` : v
        }
        tickTotal={4}
        title={selectedAttributes[0]}
      />
      <YAxis
        tickFormat={(v) =>
          storeStats[selectedAttributes[1]].type === "percentage" ? `${v}%` : v
        }
        tickTotal={4}
        title={selectedAttributes[1]}
      />
      <MarkSeries colorType="literal" sizeRange={[5, 5]} data={series} />
      <LabelSeries data={series} labelAnchorX="start" labelAnchorY="text-top" />
    </XYPlot>
  );
};

const XYZChart = (props) => {
  const { width, height, selectedAttributes, stores, storeStats } = props;

  const data = stores
    .map((s) =>
      selectedAttributes.reduce((map, a) => {
        map[a] =
          storeStats[a].type === "percentage" ? s.data[a] * 100 : s.data[a];
        return map;
      }, {})
    )
    .map((s, index) => ({
      ...s,
      color: storeColors[index],
    }));

  const domain = selectedAttributes.map((a) => ({
    name: a,
    domain:
      storeStats[a].type === "boolean"
        ? [0, 1]
        : [storeStats[a].min, storeStats[a].max],
    tickFormat: (t) =>
      storeStats[a].type === "percentage"
        ? `${Number(round(t).toFixed(2))}%`
        : Number(t.toFixed(2)),
  }));
  return (
    <RadarChart
      hideInnerMostValues={true}
      data={data}
      domains={domain}
      colorType="literal"
      style={{
        labels: {
          fontSize: 10,
        },
        polygons: {
          fillOpacity: 0,
          strokeWidth: 2,
        },
      }}
      margin={{
        top: 100,
        right: 150,
        bottom: 100,
        left: 150,
      }}
      tickFormat={(t) => ""}
      width={width}
      height={height}
    ></RadarChart>
  );
};

const CompareStores = (props) => {
  const { selectedAttributes, stores, storeStats } = props;
  return (
    <AutoSizer>
      {({ width, height }) =>
        (selectedAttributes.length === 1 && (
          <XChart
            width={width}
            height={height}
            selectedAttributes={selectedAttributes}
            stores={stores}
            storeStats={storeStats}
          />
        )) ||
        (selectedAttributes.length === 2 && (
          <XYChart
            width={width}
            height={height}
            selectedAttributes={selectedAttributes}
            stores={stores}
            storeStats={storeStats}
          />
        )) || (
          <XYZChart
            width={width}
            height={height}
            selectedAttributes={selectedAttributes}
            stores={stores}
            storeStats={storeStats}
          ></XYZChart>
        )
      }
    </AutoSizer>
  );
};

export default React.memo(CompareStores);
